<template>
  <validation-observer v-slot="{ invalid }" ref="step4">
  <b-form @submit.prevent @change="formChanged()">
    <b-row>
      <b-col cols="12">
        <b-form-group label="Cost Price" label-for="h-number" label-cols-md="4">
          <validation-provider
          #default="{errors}"
          name="Total Cost (Rs)"
          vid="purchasePrice"
          rules="required|min_value:0"
          >
          <b-form-input
            id="h-number"
            type="number"
            value="5982"
            v-model="Product.purchasePrice"
            min_value:0
            required
            @keypress="allowOnlyNumbers($event)"
            @input="sanitizeInput('purchasePrice')"
          />
          <small v-if="errors.length" class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
        </b-form-group>
      </b-col>
      
      <b-col cols="12">
        <b-form-group
          label="Selling Price (Tax Exclusive)"
          label-for="h-Selling"
          label-cols-md="4"
        >
        <validation-provider v-slot="{ errors }" name="Selling Price (Tax Exclusive)" rules="min_value:0">
          <b-form-input
            id="h-Mark"
            type="number"
            placeholder="Rs 6895"
            v-model="Product.salePrice"
            @keypress="allowOnlyNumbers($event)"
            @input="sanitizeInput('salePrice')"
          />
          <small v-if="errors.length" class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
        </b-form-group>
      </b-col>
      
      
      
      <b-col cols="12" v-if="vat">
        <b-form-group label="Sales VAT (%)" label-for="h-VAT" label-cols-md="4">
          <validation-provider v-slot="{ errors }" name="Sales VAT (%)" rules="min_value:0">
          <b-form-input
            id="h-Mark"
            type="number"
            placeholder="Ex : 15%"
            v-model="Product.saleTaxPercentage"
            @keypress="allowOnlyNumbers($event)"
            @input="sanitizeInput('saleTaxPercentage')"
          />
          <small class="text-danger">{{ errors[0] }}</small>
           </validation-provider>
        </b-form-group>
      </b-col>

      <b-col cols="12">
        <b-form-group
          label="Mark Up (%)"
          label-for="h-password"
          label-cols-md="4"
        >
          <b-form-input
            id="h-Mark"
            disabled
            type="number"
            placeholder=""
            v-model="Product.markUpPercentage"
          />
        </b-form-group>
      </b-col>
      
    </b-row>
  </b-form>
</validation-observer>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  props: {
    Product: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      vat: JSON.parse(localStorage.getItem("userData")).vat,
    };
  },
  methods: {
    formChanged() {
    this.$emit("onchange", this.Product);
  },
  async formValidation() {
    let stepValidation = await this.$refs.step4.validate();
    return stepValidation;
  },
  allowOnlyNumbers(event) {
    const charCode = event.which ? event.which : event.keyCode;

      if (
        (charCode < 48 || charCode > 57) &&  
        charCode !== 46 &&                   
        charCode !== 8                       
      ) {
        event.preventDefault();
          }
      
      if (charCode === 46 && event.target.value.includes('.')) {
        event.preventDefault();
      }
  },
  sanitizeInput(field) {
    let sanitizedValue = this.Product[field].toString().replace(/[^0-9.]/g, '');
    
      const parts = sanitizedValue.split('.');
      if (parts.length > 2) {
        sanitizedValue = parts[0] + '.' + parts[1]; 
      }
    
      this.Product[field] = sanitizedValue ? parseFloat(sanitizedValue) : 0;
  },

    formChanged() {
      this.$emit("onchange", this.Product);
    },
    async formValidation(){
      let stepValidation = await this.$refs.step4.validate();
      return stepValidation;
    },
  },
  watch: {
    Product(newProduct, oldProduct) {
      this.formChanged();
    },
  },
};
</script>
